/** PipeKit engineering-core — runtime guards for untrusted numeric input. */

import { getDataset } from "./datasets.js";

export function assertFinite(n: number, label: string): void {
  if (!Number.isFinite(n)) throw new Error(`Non-finite input '${label}'`);
}
export function assertPositive(n: number, label: string): void {
  if (!(n > 0)) throw new Error(`Expected positive '${label}', got ${n}`);
}

/** Release gate: pending reference data may not produce a normal calculation. */
export function assertDatasetRunnable(id: string): void {
  const dataset = getDataset(id);
  if (dataset.status === "pending-verification") {
    throw new Error(`Dataset '${id}' is pending verification and cannot produce a design result`);
  }
}